import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { CourseStatus } from "@domain/lms/course/courseDraft";
import { courseStatusColor } from "@ui/styles/colors";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";

interface CourseStatusLabelProps extends React.HTMLAttributes<HTMLDivElement> {
	status: CourseStatus;
}
export const CourseStatusLabel: React.FC<CourseStatusLabelProps> = ({ status, ...htmlProps }) => {
	return (
		<Container status={status} {...htmlProps}>
			• {I18n.t(`course.status.${status}`)}
		</Container>
	);
};

const Container = styled(RoundedBlock)<{ status: CourseStatus }>`
	padding: 5px 10px;
	border-radius: 15px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ status }) => courseStatusColor[status]};
	text-align: center;
`;
